var en = {
  'Home': 'Lol'
};
export default en;